import React, { useCallback, useEffect, useState } from 'react';
import SideBanner from 'components/layout/SideBanner';
import { useMFAContext } from 'hooks/useMFA';
import { useHistory } from 'react-router-dom';
import TypeToken from './TypeToken';
import ValidationToken from './ValidationToken';
import { requestGetUserById } from './services';
import { Body, Container, Content } from './styles';

const MFARegister = () => {
  const [steppers] = useState(['Envio do token', 'Validação do token']);
  const [step, setStep] = useState(1);
  const [userInfo, setUserInfo] = useState({});
  const [contactId, setContactId] = useState(null);

  const history = useHistory();

  const {
    credentials: { login },
    userId,
  } = useMFAContext();

  useEffect(() => {
    async function loadData() {
      try {
        const response = await requestGetUserById(userId, login);
        setUserInfo({
          document: login,
          userId,
          contacts: response?.contacts || [],
        });
      } catch (error) {
        history.push('/');
      }
    }
    if (login) {
      loadData();
    }
  }, [login, setUserInfo, history, userId]);

  const buildComponente = useCallback(() => {
    return (
      {
        1: (
          <TypeToken
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setContactId={setContactId}
          />
        ),
        2: (
          <ValidationToken
            step={step}
            setStep={setStep}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            contactId={contactId}
          />
        ),
      }[step] || (
        <TypeToken
          step={step}
          setStep={setStep}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          setContactId={setContactId}
        />
      )
    );
  }, [step, userInfo, setUserInfo, setStep, contactId]);

  const buildHeader = (stepParam) => {
    return (
      {
        1: {
          h1: 'Duplo fator de Autenticação',
          h2: 'Informe de que forma deseja receber o código',
        },
        3: {
          h1: 'Insira o código',
          h2: `Informe o código recebido`,
        },
      }[stepParam] || { h1: '', h2: '' }
    );
  };

  return (
    <Container>
      <SideBanner
        activated={step}
        header={buildHeader(step)}
        steppers={steppers}
      />
      <Content>
        <Body>{buildComponente()}</Body>
      </Content>
    </Container>
  );
};

export default MFARegister;
